import { AfterViewInit, Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core'
import { GoogleMapsService } from 'src/app/injectable/google-maps-service'
import { UnsubscribeOnDestroy } from 'src/app/utility'
import { ListingQuery } from '../../../../../../../graphql'

@Component({
    selector: 'app-listing-map',
    templateUrl: 'listing-map.html'
})
export class ListingMapComponent extends UnsubscribeOnDestroy implements AfterViewInit, OnDestroy {
    @Input() listing: ListingQuery['listing']
    @ViewChild('map') map: ElementRef

    // Constructor
    private marker: google.maps.Marker
    constructor(private _googleMapsService: GoogleMapsService) {
        super()
    }

    // Public
    ngAfterViewInit() {
        this.initialize()
    }

    // Private
    private initialize() {
        const latLng = {
            lat: this.listing.obfuscatedLocation.location.lat,
            lng: this.listing.obfuscatedLocation.location.lng
        }
        const sub = this._googleMapsService.createMap(this.map.nativeElement, {
            center: latLng,
            zoom: 12,
            mapId: 'c380b190b4343d18',
            disableDefaultUI: true,
        }).subscribe(map => {
            // TODO: design calls for a custom advancedMarkerElement here
            this.marker = new google.maps.Marker({
                position: latLng,
                map
            })
        })

        this._subscriptions.push(sub)
    }

    ngOnDestroy() {
        super.ngOnDestroy()
        this?.marker?.setMap(null)
    }
}
